import { AgreementsDocumentFileModel } from '.'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class AgreementsDocumentVersion extends BaseModel {
  id: string = ''
  version: string = ''
  url: string = ''
  isActual: boolean = false
  file: AgreementsDocumentFileModel | null = null

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['file'])

      if (isUnknownObject(data.file)) {
        this.file = new AgreementsDocumentFileModel(data.file)
      }
    }
  }

  get sourceLink(): string {
    return this.url || this.file?.source || ''
  }
}
